// @ts-nocheck
import React from 'react';
import IconCamSlash from '../../../assets/icons/added/camera-disabled.svg';
import BaseIndicator from 'jitsi/base/react/components/web/BaseIndicator';
/**
 * React {@code Component} for showing an audio muted icon with a tooltip.
 *
 * @returns {Component}
 */
const ThumbnailCameraIndicator = ({ tooltipPosition }) => (React.createElement(BaseIndicator, { icon: IconCamSlash, iconId: 'cam-disabled', iconSize: 16, id: 'videoMuted', tooltipKey: 'videothumbnail.videomute', tooltipPosition: tooltipPosition }));
export default ThumbnailCameraIndicator;
